import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

import {
  TenantFrontendApi_GetTenant,
  TenantFrontendApi_UpdateTenant,
  TenantFrontendApi_PatchIsTestStatusOfTenant,
  TenantFrontendApi_GetTenantList
} from "./TenantFrontendApi";

import { Translate } from "./Translator";
import Header from "./Header";
import MainMenu from "./MainMenu";
import Footer from "./Footer";
import BlueBar from "./BlueBar";

import HomeLogo from "./Assets/HomeLogo.png";

import './Tenant.css';
import './EditUser.css';
import './EditTenant.css';

function EditTenant() {
  const navigate = useNavigate();

  const [mRepaint, SetRepaint] = useState(false);
  const [mTenant, SetTenant] = useState(null);
  const [mTenantGuid, SetTenantGuid] = useState();
  const [mTenantList, SetTenantList] = useState([]);
  const [mCanNotMakeResellerTenant, SetCanNotMakeResellerTenant] = useState("");
  const [mTestTenantsRemains, SetTestTenantsRemains] = useState(0);
  const [mShowCanNotSetDemoTenant, SetShowCanNotSetDemoTenant] = useState(false);
  
  const [isClient, setIsClient] = useState(false);
  const maxDemoTenants = parseInt(sessionStorage.getItem("maxdemotenants") || "0", 10);
  const isValidMaxDemo = !isNaN(maxDemoTenants) && maxDemoTenants !== 0;

  const [mShowMakeTenantAReseller, SetShowMakeTenantAReseller] = useState()

  useEffect(() => {
    let isMounted = true;  // Track if component is mounted
  
    setIsClient(true);
  
    async function GetTenant(guid) {
      try {
        const response = await TenantFrontendApi_GetTenant(sessionStorage.getItem("token"), guid);
        if (isMounted) SetTenant(response.data); // Update only if mounted
      } catch (ex) {
        handleApiError(ex, "tenant");
      }
    }
  
    async function GetTenantList() {
      try {
        const response = await TenantFrontendApi_GetTenantList(sessionStorage.getItem("token"));
        if (isMounted) SetTenantList(response.data); // Update only if mounted
      } catch (ex) {
        handleApiError(ex, "tenant");
      }
    }
  
    function handleApiError(ex, type) {
      let errorCode = null;
      try {
        if (ex.response && ex.response.status) {
          errorCode = ex.response.status;
        }
        navigate(`../error?errorcode=${errorCode}&error=${type}`);
      } catch {}
      console.log("Error: ", ex);
    }
  
    const urlParams = new URLSearchParams(window.location.search);
    const tenantGuid = urlParams.get('tenantguid');
    SetTenantGuid(tenantGuid);
  
    GetTenant(tenantGuid);
    GetTenantList();

    SetShowMakeTenantAReseller(sessionStorage.getItem("IsSuperTenant") === "1" ? false : true) 
  
    return () => {
      isMounted = false;  // Cleanup on unmount
    };
  }, [navigate]);
  
  useEffect(() => {
    const maxDemoTenants = parseInt(sessionStorage.getItem("maxdemotenants"), 10) || 0;
    const usedDemoCount = (mTenantList || []).filter(t => t.IsTest).length;
    SetTestTenantsRemains(maxDemoTenants - usedDemoCount);
  }, [mTenantList]);
  
  useEffect(() => {
    setIsClient((prevState) => ({
      ...prevState, 
      SuperTenantManageTenants: mTenant?.SuperTenantManageTenants || false,
      AllowIncreaseDecreaseLicenses: mTenant?.AllowIncreaseDecreaseLicenses || false,  // Set this based on your tenant data
    }));
  }, [mTenant]); // Runs when `mTenant` changes
  

  const SetName = (val) => { mTenant.Company = val; SetRepaint(!mRepaint); };
  const SetAddress1 = (val) => { mTenant.CompanyAddressLine1 = val; SetRepaint(!mRepaint); };
  const SetAddress2 = (val) => { mTenant.CompanyAddressLine2 = val; SetRepaint(!mRepaint); };
  const SetTenantApiSetting = (val) => { mTenant.ApiSettings = val; SetRepaint(!mRepaint); };
  const SetPostalCode = (val) => { mTenant.CompanyPostalCode = val; SetRepaint(!mRepaint); };
  const SetCity = (val) => { mTenant.CompanyCity = val; SetRepaint(!mRepaint); };
  const SetCountry = (val) => { mTenant.CompanyCountry = val; SetRepaint(!mRepaint); };
  const SetPhone = (val) => { mTenant.CompanyPhone = val; SetRepaint(!mRepaint); };
  const SetVATNumber = (val) => { mTenant.VATNumber = val; SetRepaint(!mRepaint); };
  const SetCustomId = (val) => { mTenant.CustomId = val; SetRepaint(!mRepaint); };

  const SetIsSuperTenant = (val) => {
    if (mTenant.SuperTenantGuid)
    {
      SetCanNotMakeResellerTenant("Show animation");
    }
    else
    {
      mTenant.IsSuperTenant = val;
      SetRepaint(!mRepaint);
    }
  };

  const SetIsTest = (val) => {
    if (val && !CheckIfItCanBeSelected()) return;
    mTenant.IsTest = val;
    SetRepaint(!mRepaint);
  };

  const SetSuperTenantManageTenants = (val) => {
    mTenant.SuperTenantManageTenants = val;
    SetRepaint(!mRepaint);
  };

  const SetSuperTenantManageLicenses = (val) =>{
    mTenant.SuperTenantManageLicences = val;
    SetRepaint(!mRepaint);
  }

  function CheckIfItCanBeSelected() {
    const maxDemoTenantsRaw = sessionStorage.getItem("maxdemotenants");
    const max = parseInt(maxDemoTenantsRaw, 10);
  
    console.log("maxdemotenants:", maxDemoTenantsRaw);
  
    if (!max || max === 0) {
      SetShowCanNotSetDemoTenant(
        "You cannot create this tenant as a demo tenant because your account does not have demo access enabled. Please contact our support team to request the addition of demo tenants to your account."
      );
      return false;
    }
  
    const used = mTenantList.filter(t => t.IsTest).length;
  
    if (max - used <= 0) {
      SetShowCanNotSetDemoTenant(
        "You have reached the maximum number of demo accounts. This tenant cannot be set as a test tenant."
      );
      return false;
    }
  
    return true;
  }
  

  async function UpdateTenant() {
    try {
      const response = await TenantFrontendApi_UpdateTenant(
        sessionStorage.getItem("token"),
        mTenantGuid,
        mTenant.Company,
        mTenant.CompanyAddressLine1,
        mTenant.CompanyAddressLine2,
        mTenant.CompanyPostalCode,
        mTenant.CompanyCity,
        mTenant.CompanyCountry,
        mTenant.CompanyPhone,
        mTenant.VATNumber,
        mTenant.ApiSettings,
        mTenant.CustomId,
        mTenant.IsSuperTenant,
        mTenant.SuperTenantManageTenants,
        mTenant.SuperTenantManageLicences
      );
      console.log(JSON.stringify(response));
      navigate(`../tenant?tenantguid=${mTenantGuid}`);
    } catch (ex) {
      console.log("Error: ", ex?.response?.data?.Exception || ex);
    }
  }

  async function PatchIsTestTenantStatus() {
    try {
      const token = sessionStorage.getItem("token")?.trim();
      await TenantFrontendApi_PatchIsTestStatusOfTenant(token, mTenantGuid, mTenant.IsTest);
    } catch (ex) {
      console.log("Error: ", ex?.response?.data?.Exception || ex);
    }
  }

  function UpdateInformation() {
    PatchIsTestTenantStatus();
    UpdateTenant();
  }

  function languageChanged() {
    SetRepaint(!mRepaint);
  }

  const TenantCheckbox = ({ label, checked, onChange}) => (
    <tr height="30">
      <td width="40" />
      <td className="paddingleftResellerPrivilegesCehckboxes">
        <label>
          <input
            type="checkbox"
            checked={checked || false}
            onChange={onChange}
            disabled={mTenant.IsSuperTenant ? false : true}
          />
          &nbsp;
          <span className={mTenant.IsSuperTenant ? "bold" : "grey"}>{label}</span>
        </label>
      </td>
      <td />
    </tr>
  );

  if (!isClient || !mTenant) {
    return <div>Loading tenant data...</div>;
  }

  return (
    <span>
      <Header onLanguageChanged={languageChanged} />
      <MainMenu MainMenuNumber={1} />

      <table width="1200" cellPadding={0} cellSpacing={0} align="center">
                <tbody>                
                    <tr className="pagetop3">
                        <td height="75" valign="bottom">
                            <table width="100%" cellPadding={0} cellSpacing={0} className="down10px">
                                <tbody>
                                    <tr height="60">
                                        <td
                                            width="100%"
                                            align="left"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                flexWrap: 'nowrap'
                                            }}
                                        >
                                        {/* Home Logo */}
                                        <a
                                            href="/"
                                            onClick={(e) => {
                                                if (!e.ctrlKey && !e.metaKey && e.button === 0) {
                                                    e.preventDefault();
                                                    navigate("/");
                                                }
                                            }}
                                            title="Home"
                                        >
                                            <img
                                                alt="Home logo"
                                                className="HomeLogo pointer"
                                                src={HomeLogo}
                                                style={{ cursor: "pointer" }}
                                        />
                                        </a>

                                                {/* Separator */}
                                                <span className="blue">/</span>

                                                {/* Tenants */}
                                                <a
                                                    href="../reseller"
                                                    onClick={(e) => {
                                                        if (!e.ctrlKey && !e.metaKey && e.button === 0) {
                                                            e.preventDefault();
                                                            navigate("../reseller");
                                                        }
                                                    }}
                                                    className="black bold pointer underline"
                                                    style={{ textDecoration: "underline", cursor: "pointer" }}
                                                >
                                                    {Translate("Tenants")}
                                                </a>

                                                {/* Separator */}
                                                <span className="blue">/</span>

                                                {/* Company */}
                                                <a
                                                    href={`../tenant?tenantguid=${mTenantGuid}`}
                                                    onClick={(e) => {
                                                        if (!e.ctrlKey && !e.metaKey && e.button === 0) {
                                                            e.preventDefault();
                                                            navigate(`../tenant?tenantguid=${mTenantGuid}`);
                                                        }
                                                    }}
                                                    className="black bold pointer underline"
                                                    style={{ textDecoration: "underline", cursor: "pointer" }}
                                                >
                                                    {mTenant.Company}
                                                </a>

                                                {/* Separator */}
                                                <span className="blue">/</span>

                                                {/* Edit (non-clickable) */}
                                                <span className="bold">{Translate("Edit")}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    <tr height="20"/>

                    
                    <tr>
                        <td className="bold fontsize30 width100 width30">{Translate("Edit tenant")}</td>
                        <td></td>
                    </tr>

                    <tr height="40"/>

                    <tr>
                        <td className="width30">
                            <BlueBar/>
                        </td>
                    </tr>           

                    <tr height="40"/>

                </tbody>
            </table>

            {/* Edit a specific tenant */}
            <table className="usermainsettingtable" width="1200" cellPadding={0} cellSpacing={0} align="center">
            <tbody>
                <tr height="20" />

                <tr>
                <td width="40" />
                <td className="bold fontsizelarge">{Translate("Information")}</td>
                <td />
                </tr>

                <tr height="20" />

                {/* Company Name */}
                <tr>
                <td width="40" />
                <td className="bold fontsizesmall">{Translate("Company name")}</td>
                </tr>

                <tr height="10" />

                <tr height="40">
                <td width="40" />
                <td width="1000">
                    <input
                    value={mTenant?.Company || ""}
                    onChange={(e) => SetName(e.target.value)}
                    className="inputtd"
                    />
                </td>
                <td />
                </tr>

                <tr height="20" />

                {/* Address */}
                {
                [
                { label: "Address 1", key: "CompanyAddressLine1", setter: SetAddress1 },
                { label: "Address 2", key: "CompanyAddressLine2", setter: SetAddress2 },
                { label: "Postal code", key: "CompanyPostalCode", setter: SetPostalCode },
                { label: "City", key: "CompanyCity", setter: SetCity },
                { label: "Country", key: "CompanyCountry", setter: SetCountry },
                { label: "Phone", key: "CompanyPhone", setter: SetPhone },
                { label: "VAT number", key: "VATNumber", setter: SetVATNumber },
                { label: "Custom ID", key: "CustomId", setter: SetCustomId },
                ].map(({ label, key, setter }) => (
                <React.Fragment key={key}>
                    <tr>
                    <td width="40" />
                    <td className="bold fontsizesmall">{Translate(label)}</td>
                    </tr>
                    <tr height="10" />
                    <tr height="40">
                    <td width="40" />
                    <td width="1000">
                        <input
                        value={mTenant?.[key] || ""}
                        onChange={(e) => setter(e.target.value)}
                        className="inputtd"
                        />
                    </td>
                    <td />
                    </tr>
                    <tr height="20" />
                </React.Fragment>
                ))}

                {/* Tenant API Settings */}
                <tr>
                <td width="40" />
                <td className="bold fontsizesmall">{Translate("Tenant API settings")}</td>
                </tr>

                <tr height="10" />

                <tr height="80">
                <td width="40" />
                <td>
                    <textarea
                    value={mTenant?.ApiSettings || ""}
                    onChange={(e) => SetTenantApiSetting(e.target.value)}
                    className="textareaedittenat"
                    />
                </td>
                <td />
                </tr>

                <tr height="20"/>

                {/* Making a tenant a reseller tenant checkbox */}
                {mShowMakeTenantAReseller && (
                  <tr height="40">
                    <td width="40" />
                    <td>
                        <label>
                        <input
                            type="checkbox"
                            checked={mTenant?.IsSuperTenant || false}
                            onChange={(e) => SetIsSuperTenant(e.target.checked)}
                        />
                        &nbsp;
                        <span className="bold">{Translate("Make this tenant a reseller")}</span>
                        </label>
                    </td>
                    <td/>
                  </tr>)}

                {mShowMakeTenantAReseller && (<tr height="20"></tr>)}

                {/* Check for Super Tenant and session storage flag */}
                {sessionStorage.getItem("IsSuperTenant") !== "1" && (
                <>
                    {/* Allow reseller to add/remove tenants */}
                    <TenantCheckbox
                    label={Translate("Allow this reseller to add and remove tenants")}
                    checked={mTenant?.SuperTenantManageTenants || false}
                    onChange={(e) => SetSuperTenantManageTenants(e.target.checked)}
                    />

                    {/* Allow reseller to increase/decrease number of licenses (still to be completed) */}
                    <TenantCheckbox
                    label={Translate("Allow this reseller tenant to increase/decrease the number of licenses")}
                    checked={mTenant?.SuperTenantManageLicences || false}
                    onChange={(e) => SetSuperTenantManageLicenses(e.target.checked)}
                    />
                    <tr height="15" />
                </>
                )}

                {sessionStorage.getItem("IsSuperTenant") !== "1" && (
                <>
                    <tr height="20">
                    <td width="40" />
                    <td>
                        <label>
                          <input
                                  type="checkbox"
                                  disabled={mCanNotMakeResellerTenant}
                                  checked={mTenant?.IsTest || false}
                                  onChange={(e) => SetIsTest(e.target.checked)}
                          />
                              &nbsp;
                              <span className={mTestTenantsRemains === 0 ? "gray" : "bold"}>{Translate("Set this tenant as a test tenant")}</span>
                              &nbsp;&nbsp;
                              
                              {isValidMaxDemo && (
                                <span className={mTestTenantsRemains === 0 ? "gray" : ""}>
                                  {mTestTenantsRemains} {Translate("out of")} {maxDemoTenants} {Translate("available")}
                                </span>
                              )}
                        </label>
                      </td>
                    <td />
                    </tr>
                    <tr height="30" />
                </>
                )}
            
                {/* Update Button */}
                <tr>
                    <td width="40" />
                    <td className="bold fontsizesmall">
                        <button className="saveusersettingsbutton bold" onClick={UpdateInformation}>
                        {Translate("Update information")}
                        </button>
                    </td>
                </tr>

                <tr height="20" />
            </tbody>
            </table>

            
            {/*Footer Table*/}
            <table>
                <tbody>
                    <tr height="60"></tr>
                </tbody>
            </table>

      <Footer />

      {/* Modals */} {/* Managing reseller tenant privilege */}
      <Modal animation={false} style={{ opacity: 1 }} show={mCanNotMakeResellerTenant !== ""} onHide={() => SetCanNotMakeResellerTenant("")} centered>
        <Modal.Header closeButton>
          <Modal.Title align="center">
            <span>This tenant is part of another tenant, so it cannot be made a reseller tenant.</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer align="center">
          <Button variant="dark" onClick={() => SetCanNotMakeResellerTenant("")}>{Translate("Ok")}</Button>
        </Modal.Footer>
      </Modal>
      
      {/* Managing tenant demo accounts */}
      <Modal animation={false} style={{ opacity: 1 }} show={mShowCanNotSetDemoTenant} onHide={() => SetShowCanNotSetDemoTenant(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title align="center">
            <span>{mShowCanNotSetDemoTenant}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer align="center">
          <Button variant="dark" onClick={() => SetShowCanNotSetDemoTenant(false)}>{Translate("Ok")}</Button>
        </Modal.Footer>
      </Modal>
    </span>
  );
}

export default EditTenant;
